import { defineMessage } from "@lingui/macro";

export const NODE_TYPES = {
  STATIC: "Static",
  FUNCTION: "Function",
  MODEL_FUNCTION: "ModelFunction",
  FIELD: "Field",
  PARENT_FIELD: "ParentField",
  REF_FIELD: "RefField",
  LOOKUP: "Lookup",
  PARENT_LOOKUP: "ParentLookup"
};

export const DATA_TYPES = {
  STRING: "String",
  DATE_TIME: "DateTime",
  BOOLEAN: "Boolean",
  NUMBER: "Number",
  GEOLOCATION: "Geolocation",
  JSON_LIST: "JSONList",
  REFERENCE: "Reference",
  STRING_LIST: "StringList",
  JSON: "JSON",
  XML: "XML",
  DATE: "Date",
  REFERENCE_LIST: "ReferenceList",
  CURRENCY: "Currency",
  CHECKLIST: "CheckList",
  ACTIVITYINSTANCE: "ActivityInstance",
  ANY: "Any",
  USER: "User",
  MULTI_USER: "UserList",
  USERANDGROUP: "UserAndGroup",
  USERANDGROUPLIST: "UserAndGroupList"
};

export const SYSTEM_MODELS = {
  SYSTEM: "System",
  PROCESS_BASE: "ProcessBase",
  DATASET_BASE: "DatasetBase",
  PROJECT_BASE: "ProjectBase",
  CASE_BASE: "CaseBase",
  FORM_BASE: "FormBase",
  USER: "User",
  USER_BASE: "UserBase"
};

export const FLOW_TYPE = {
  PROCESS: "Process",
  DATASET: "Dataset",
  DATASET_VIEW: "DatasetView",
  USER: "User",
  PROJECT: "Project",
  CASE: "Case",
  INTEGRATION: "Integration",
  APPLICATION: "Application",
  FORM: "Form",
  PORTAL: "Portal",
  LIST: "List",
  EXTERNAL_DATA: "ExternalData",
  ANALYTICS_REPORT: "AnalyticsReport",
  DECISION_TABLE: "DecisionTable"
};

export const FIELD_TYPES = {
  TEXT: "Text",
  TEXT_AREA: "Textarea",
  NUMBER: "Number",
  CURRENCY: "Currency",
  CURRENCY_UNIT: "CurrencyUnit",
  DATE: "Date",
  DATE_TIME: "DateTime",
  EMAIL: "Email",
  BOOLEAN: "Boolean",
  IMAGE: "Image",
  SELECT: "Select",
  MULTI_SELECT: "Multiselect",
  SLIDER: "Slider",
  USER: "User",
  MULTI_USER: "MultiUser",
  REFERENCE: "Reference",
  RICH_TEXT: "RichText",
  STAR_RATING: "StarRating",
  ATTACHMENT: "Attachment",
  SMART_ATTACHMENT: "SmartAttachment",
  LOCATION: "Location",
  SIGNATURE: "Signature",
  REMOTE_LOOKUP: "RemoteLookup",
  COUNTER: "Counter",
  CHECK_LIST: "Checklist",
  CHECK_BOX: "Checkbox",
  LIST: "List",
  GROUP: "Group",
  AGGREGATION: "Aggregation",
  USERGROUPLIST: "UserGroupList",
  JSON: "JSON",
  XML: "XML",
  MEMBER: "Member",
  STEPFIELD: "StepField",
  TABLEFIELD: "TableField",
  SEQUENCE_NUMBER: "SequenceNumber",
  USERANDGROUP: "UserAndGroup",
  GROUPS: "Groups",
  BUTTON: "Button",
  RADIO: "Radio",
  DROPDOWN_LIST: "DropdownList",
  RAW_JSON: "RawJson",
  GEOLOCATION: "Geolocation",
  SCANNER: "Scanner",
  LABEL: "Label",
  GRID: "Grid",
  ROLES: "Roles",
  OBJECT: "Object",
  OBJECT_LIST: "ObjectList",
  STRING_LIST: "StringList",
  CUSTOM: "Custom"
};

export const CUSTOM_COMPONENT_TYPES = {
  PAGE: "Page",
  FORM_FIELD: "FormField"
};

export const WIDGET_TYPES = {
  CUSTOM: "Custom",
  SYSTEM: "System"
};

export const DATA_TYPE_LABELS = {
  [FIELD_TYPES.TEXT]: "Text",
  [FIELD_TYPES.NUMBER]: "Number",
  [FIELD_TYPES.BOOLEAN]: "Boolean",
  [FIELD_TYPES.OBJECT]: "Object",
  [FIELD_TYPES.STRING_LIST]: "Array of strings",
  [FIELD_TYPES.OBJECT_LIST]: "Array of objects"
};

export const INPUT_PARAMETER_TYPES = {
  INPUT: "Input",
  STATIC_DROPDOWN: "StaticDropdown"
};

export const INPUT_PARAMETER_DATATYPES = {
  NUMBER: "Number",
  STRING: "String"
};

export const FIELD_ICONS = {
  [FIELD_TYPES.TEXT]: "SingleLine",
  [FIELD_TYPES.TEXT_AREA]: "MultiLine",
  [FIELD_TYPES.NUMBER]: "Number",
  [FIELD_TYPES.CURRENCY]: "DollarCircle",
  [FIELD_TYPES.CURRENCY_UNIT]: "DollarCircle",
  [FIELD_TYPES.DATE]: "Date",
  [FIELD_TYPES.DATE_TIME]: "DateTime",
  [FIELD_TYPES.EMAIL]: "Email",
  [FIELD_TYPES.BOOLEAN]: "Toggle",
  [FIELD_TYPES.SELECT]: "DropdownBox",
  [FIELD_TYPES.DROPDOWN_LIST]: "DropdownBox",
  [FIELD_TYPES.MULTI_SELECT]: "CheckSquare",
  [FIELD_TYPES.CHECK_BOX]: "CheckSquare",
  [FIELD_TYPES.ATTACHMENT]: "Attachment",
  [FIELD_TYPES.SMART_ATTACHMENT]: "SmartAttachment",
  [FIELD_TYPES.USER]: "UserCircle",
  [FIELD_TYPES.MULTI_USER]: "UserCircle",
  [FIELD_TYPES.CHECK_LIST]: "CheckList",
  [FIELD_TYPES.SLIDER]: "Slider",
  [FIELD_TYPES.STAR_RATING]: "StarOutline",
  [FIELD_TYPES.COUNTER]: "Slider",
  [FIELD_TYPES.IMAGE]: "Image",
  [FIELD_TYPES.GROUP]: "UserCircle",
  [FIELD_TYPES.REFERENCE]: "Lookup",
  [FIELD_TYPES.AGGREGATION]: "Aggregation",
  [FIELD_TYPES.SIGNATURE]: "Signature",
  [FIELD_TYPES.RICH_TEXT]: "Richtext",
  [FIELD_TYPES.REMOTE_LOOKUP]: "RemoteLookup",
  [FIELD_TYPES.JSON]: "RemoteLookup",
  [FIELD_TYPES.XML]: "RemoteLookup",
  [FIELD_TYPES.RAW_JSON]: "RemoteLookup",
  [FLOW_TYPE.PROCESS]: "Process",
  [FIELD_TYPES.SEQUENCE_NUMBER]: "SequenceNumber",
  [FIELD_TYPES.USERANDGROUP]: "UserCircle",
  [FIELD_TYPES.GROUPS]: "UserCircle",
  [FIELD_TYPES.USERGROUPLIST]: "UserCircle",
  [FIELD_TYPES.GEOLOCATION]: "Geolocation",
  [FIELD_TYPES.RADIO]: "Radio",
  [FIELD_TYPES.SCANNER]: "Scanner",
  [FIELD_TYPES.LABEL]: "Text",
  [FIELD_TYPES.GRID]: "Grid",
  [FIELD_TYPES.ROLES]: "Roles",
  [WIDGET_TYPES.CUSTOM]: "Custom",
  [FIELD_TYPES.OBJECT]: "Object",
  [FIELD_TYPES.OBJECT_LIST]: "ObjectList",
  [FIELD_TYPES.STRING_LIST]: "StringList"
};

export const MODEL_TO_PARENT_MODEL = {
  [FLOW_TYPE.PROCESS]: SYSTEM_MODELS.PROCESS_BASE,
  [FLOW_TYPE.PROJECT]: SYSTEM_MODELS.PROJECT_BASE,
  [FLOW_TYPE.DATASET]: SYSTEM_MODELS.DATASET_BASE,
  [FLOW_TYPE.CASE]: SYSTEM_MODELS.CASE_BASE,
  [FLOW_TYPE.FORM]: SYSTEM_MODELS.FORM_BASE,
  [FLOW_TYPE.USER]: SYSTEM_MODELS.USER_BASE,
  [FLOW_TYPE.EXTERNAL_DATA]: SYSTEM_MODELS.SYSTEM,
  [FLOW_TYPE.DECISION_TABLE]: SYSTEM_MODELS.SYSTEM
};

export const CONSTRAINT_CONTEXT = {
  WITHIN: "Within",
  ACROSS: "Across"
};

export const CONSTRAINT_TYPES = {
  UNIQUE: "Unique"
};

export const COLUMN_TYPES = {
  FIELD: "Field",
  SECTION: "Section",
  MODEL: "Model",
  RICH_TEXT: "RichText",
  PAGE: "Page",
  BUTTON: "Button",
  GRID: "Grid",
  WIDGET: "Widget"
};

export const RHS_TYPE = {
  FIELD: {
    Name: "Field",
    Label: "Field"
  },
  VALUE: {
    Name: "Value",
    Label: "Value"
  }
};

export const LAYOUT_GRID_TRACK_SIZE = {
  FOUR_COL: 4,
  SIX_COL: 6
};

export const LIST_DATASOURCE_TYPE = {
  DATASET: "Dataset",
  LIST: "List",
  DATAFORM: "Form",
  STATIC: "Static"
};
export const WIDGET_TYPE_FIELDS = [
  FIELD_TYPES.AGGREGATION,
  FIELD_TYPES.REMOTE_LOOKUP,
  FIELD_TYPES.RADIO,
  FIELD_TYPES.SCANNER
];

export const FIELD_ID = {
  MAX_LIMIT: 64,
  TRUNCATE_LIMIT: 60
};

export const CHILDTABLE_ID = FIELD_ID;

export const DEFAULT_FIELD_LIMIT = {
  [FIELD_TYPES.BUTTON]: 100,
  [FIELD_TYPES.GEOLOCATION]: 1
};

export const DEFAULT_FORM_META_LIMIT = {
  MaxFieldLimit: 1000,
  MaxChildTableLimit: 10,
  MaxChildTableColumnLimit: 100,
  MaxCustomFieldLimit: 10
};

export const COORDS = [40.866667, 34.566667];

export const DEFAULTGEODATA = {
  ZOOM: 11,
  CENTER: { lat: COORDS[0], lng: COORDS[1] },
  LOCDATA: {
    State: "",
    Country: "",
    City: "",
    ZipCode: "",
    Area: "",
    Address: "",
    Latitude: "",
    Longitude: ""
  }
};
export const LOCATIONTYPE = {
  CURRENT: "current",
  CUSTOM: "custom",
  PRESET: "preset"
};

export const MAPERRORMESSAGES = {
  OVER_QUERY_LIMIT: defineMessage`The webpage has gone over the requests limit in too short a period of time`,
  REQUEST_DENIED: defineMessage`Request Denied by the server. Please contact the support team.`,
  ERROR: defineMessage`There was a problem contacting the Google servers`,
  // eslint-disable-next-line max-len
  UNKNOWN_ERROR: defineMessage`The request could not be processed due to a server error. The request may succeed if you try again.`,
  ZERO_RESULTS: defineMessage`No result was found`,
  INVALID_REQUEST: defineMessage`Current request is invalid, please try again.`,
  NOT_FOUND: defineMessage`The information you are trying to fetch is not found`
};
export const LOCATION_SEARCH_OPTIONS = {
  // restrict your search to a specific type of result
  types: ["geocode", "establishment"],
  // this to list only specific type of place details like only geocode or only address ["address"]
  fields: [
    "name",
    "geometry",
    "formatted_address",
    "url",
    "address_components",
    "place_id"
  ],
  // to return only specified values from api also to avoid unneccessory billing
  componentRestrictions: {}
  // restrict your search to a specific country, or an array of countries & for us it is not required
};
export const MAPRESPONSESSTATUS = {
  QUERYLIMIT: "OVER_QUERY_LIMIT",
  REQUESTDENIED: "REQUEST_DENIED",
  CONNECTIONERROR: "ERROR",
  SERVERERROR: "UNKNOWN_ERROR",
  ZERORESULTS: "ZERO_RESULTS",
  INVALIDREQUEST: "INVALID_REQUEST",
  NOTFOUND: "NOT_FOUND"
};
export const PERMISSION_STATE = {
  GRANTED: "granted",
  DENIED: "denied",
  PROMPT: "prompt",
  DENIED_CODE: "PERMISSION_DENIED",
  PERMISSION_DENIED_ERROR: "PermissionDeniedError"
};
export const DEFAULTMAPPROPERTIES = {
  mapUrl: "https://maps.googleapis.com/maps/api/js?key=",
  mapCallback: "&callback=initHiddenMap",
  mapElement: {
    Id: "GmapDiv",
    elementType: "div"
  },
  scriptElement: {
    Id: "GmapScript",
    elementType: "script",
    async: true,
    defer: true
  },
  apiKey: "",
  OnLoadClearMap: true
};
export const SCANNER_ERROR_EXCEPTION = {
  NOTFOUND: "NotFoundException",
  CHECKSUM: "ChecksumException",
  FORMAT: "FormatException",
  UNSUPPORTED: "UnsupportedFileException"
};
export const SCANNER_ERROR_MESSAGES = {
  // eslint-disable-next-line max-len
  [SCANNER_ERROR_EXCEPTION.NOTFOUND]: defineMessage`The uploaded image could not be scanned. Try uploading a different image.`,
  [SCANNER_ERROR_EXCEPTION.CHECKSUM]: defineMessage`A code was found, but it's read value was not valid`,
  [SCANNER_ERROR_EXCEPTION.FORMAT]: defineMessage`A code was found, but it was in a invalid format`,
  [SCANNER_ERROR_EXCEPTION.UNSUPPORTED]: defineMessage`Unsupported file format detected`
};
export const SCANNER_EMPTY_STATE = {
  TEXT: defineMessage`Camera permission not granted`,
  SUBTEXT: defineMessage`Please allow permission to access camera`,
  ACTION_HELP: defineMessage`Help`,
  ACTION_ALLOW: defineMessage`Allow`,
  HELPURL:
    "https://helpdocs.kissflow.com/guides/enabling-camera-permission-for-kissflow"
};
export const CAMERA_FACING_MODE = { FRONT: "user", BACK: "environment" };
export const SCANNER_TIME_DURATION = 180000; //in minute
export const SCANNER_WARNING_DURATION = 120000; // in milliseconds

export const OLD_TO_NEW_COLOR_MAPPING = {
  "gray-alpha-75": "Color.Gray.700",
  "primary-blue-800": "Color.Gray.800",
  "primary-blue-500": "Color.Primary.500",
  "secondary-magenta-500": "Color.Secondary.Two.500",
  "secondary-orange-500": "Color.Secondary.Five.500",
  "secondary-green-500": "Color.Secondary.One.500",
  "secondary-purple-500": "Color.Secondary.Six.500",
  "secondary-yellow-500": "Color.Secondary.Three.500",
  "secondary-red-500": "Color.Secondary.Four.500",
  "secondary-skyblue-500": "Color.Secondary.Seven.500",
  "secondary-6-main": "Color.Primary.500",
  "secondary-5-main": "Color.Secondary.Five.500",
  "primary-left-dark15": "Color.Secondary.One.500",
  "secondary-2-light15": "Color.Secondary.Two.500",
  "primary-right-main": "Color.Secondary.Seven.500"
};

export const APPEARANCE_TYPES = {
  DEFAULT: "Default",
  CONDITIONAL: "Conditional",
  ACTIVITY: "Activity"
};
